var module = angular.module('octopusApp.infrastructure');

module.provider('stateHelper', function(){

    this.withBreadcrumb = function(text, href) {
        if (href) {
            return '<script octo-section="breadcrumbs" type="text/ng-template"><li><a href="' + href + '">' + text + '</a></li></script><ui-view></ui-view>';
        } else {
            return '<script octo-section="breadcrumbs" type="text/ng-template"><li>' + text + '</li></script><ui-view></ui-view>';
        }
    };

    this.redirectRoute = function(url, newUrl) {
        var urlGetter = newUrl;
        if (typeof newUrl === 'string') {
            urlGetter = function () {
                return newUrl;
            };
        } else if (typeof newUrl !== 'function') {
            throw "Unable to build redirection based on " + typeof(newUrl);
        }

        return {
            url: url,
            views: {
                "@app": {
                    templateUrl: 'areas/shared/views/redirect.html',
                    controller: function ($scope, $injector, $q, $location, busy) {
                        $scope.isLoading = busy.create();

                        var result = $injector.invoke(urlGetter);
                        $scope.isLoading.promise($q.when(result)).then(function (path) {
                            $location.path(path);
                            $location.replace();
                        });
                    }
                }
            },
            layout: {
                title: 'Loading...',
                tab: null
            }
        };
    };

    this.$get = function(){};
});


//////////////////
// WEBPACK FOOTER
// ./app/areas/shared/providers/routeHelperProvider.js
// module id = 5244288269360120
// module chunks = 1